import { OVERLAY_ROOT_IDS } from '@lib/components/OverlayPortal'

// Modals and confirmations render into their own roots beside #root, so a
// click on them lands outside whatever opened them. Click-outside handlers use
// this to stay open while their confirmation is up: deleting a reply from an
// open thread closed the thread on the confirmation's first click.
const OVERLAY_SELECTOR = Object.values(OVERLAY_ROOT_IDS)
  .map((id) => `#${id}`)
  .join(', ')

export const isInsideOverlay = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(OVERLAY_SELECTOR) !== null
